import { Status } from './status';
import { LegRequest } from './leg-request';
import { AircraftCategory } from './aircraft-category';
import { OfferTypeEnum } from './offer-type-enum';
import { CurrencyEnum } from '../../../../shared/models';
import { CompetitorOffer } from './competitor-offer';
import { RequestStatusEnum } from './request-status-enum';
import { OperatorPurchaseOffer } from './operator-purchase-offer';

export class SourcingRequest {
  sourcingRequestId: string;
  parentSourcingRequestId: string;
  aircraftCategories: Array<AircraftCategory>;
  status: RequestStatusEnum;
  legs: Array<LegRequest>;
  priceType: OfferTypeEnum;
  sendToXOMarketplace: boolean;
  petOnBoard: boolean;
  petNote: string;
  currency: CurrencyEnum = null;
  offerPriceInCurrency: number = null;
  allowFirmDeparture: boolean = null;
  additionalInstructions: string;
  quoteDescription: string;
  offersRequireStaffApproval: boolean;
  specialRequirements: string;
  travelReason: string;
  competitorInsights: Array<CompetitorOffer>;
  takenAircraftCategories: Array<AircraftCategory>;
  billingCurrency: CurrencyEnum;

  getSourcingRequestId(): string {
    return this.sourcingRequestId;
  }

  setSourcingRequestId(sourcingRequestId: string): SourcingRequest {
    this.sourcingRequestId = sourcingRequestId;
    return this;
  }

  getLegs(): Array<LegRequest> {
    return this.legs;
  }

  setLegs(legs: Array<LegRequest>): SourcingRequest {
    this.legs = legs;
    return this;
  }

  getStatus(): RequestStatusEnum {
    return this.status;
  }

  setStatus(status: RequestStatusEnum): SourcingRequest {
    this.status = status;
    return this;
  }

  getPriceType(): OfferTypeEnum {
    return this.priceType;
  }

  setPriceType(priceType: OfferTypeEnum): SourcingRequest {
    this.priceType = priceType;
    return this;
  }

  getAircraftCategories(): Array<AircraftCategory> {
    return this.aircraftCategories;
  }

  setAircraftCategories(categories: Array<AircraftCategory>): SourcingRequest {
    this.aircraftCategories = categories;
    return this;
  }

  getAircraftCategoryNames(): string {
    if (this.aircraftCategories && this.aircraftCategories.length) {
      return this.aircraftCategories.map((category) => category.name).join(', ');
    } else {
      return null;
    }
  }

  getSendToXOMarketplace(): boolean {
    return this.sendToXOMarketplace;
  }

  setSendToXOMarketplace(sendToXOMarketplace: boolean): SourcingRequest {
    this.sendToXOMarketplace = sendToXOMarketplace;
    return this;
  }

  setPetOnBoard(petOnBoard: boolean): SourcingRequest {
    this.petOnBoard = petOnBoard;

    return this;
  }

  getPetOnBoard(): boolean {
    return this.petOnBoard;
  }

  setPetNote(petNote: string): SourcingRequest {
    this.petNote = petNote;

    return this;
  }

  getPetNote(): string {
    return this.petNote;
  }

  getOfferPriceInCurrency(): number {
    return this.offerPriceInCurrency;
  }

  setOfferPriceInCurrency(price: number): SourcingRequest {
    this.offerPriceInCurrency = price;
    return this;
  }

  getCurrency(): CurrencyEnum {
    return this.currency;
  }

  setCurrency(currency: CurrencyEnum): SourcingRequest {
    this.currency = currency;
    return this;
  }


  setAllowFirmDeparture(value: boolean): SourcingRequest {
    this.allowFirmDeparture = value;

    return this;
  }

  getAllowFirmDeparture(): boolean {
    return this.allowFirmDeparture;
  }

  getAdditionalInstructions(): string {
    return this.additionalInstructions;
  }

  setAdditionalInstructions(additionalInstructions: string): SourcingRequest {
    this.additionalInstructions = additionalInstructions;

    return this;
  }

  getQuoteDescription(): string {
    return this.quoteDescription;
  }

  setQuoteDescription(quoteDescription: string): SourcingRequest {
    this.quoteDescription = quoteDescription;

    return this;
  }

  getOffersRequireStaffApproval(): boolean {
    return this.offersRequireStaffApproval;
  }

  setOffersRequireStaffApproval(offersRequireStaffApproval: boolean): SourcingRequest {
    this.offersRequireStaffApproval = offersRequireStaffApproval;

    return this;
  }

  getSpecialRequirements(): string {
    return this.specialRequirements;
  }

  setSpecialRequirements(specialRequirements: string): SourcingRequest {
    this.specialRequirements = specialRequirements;

    return this;
  }

  getTravelReason(): string {
    return this.travelReason;
  }

  setTravelReason(travelReason: string): SourcingRequest {
    this.travelReason = travelReason;

    return this;
  }

  getCompetitorInsights(): Array<CompetitorOffer> {
    return this.competitorInsights;
  }

  setCompetitorInsights(competitorInsights: Array<CompetitorOffer>): SourcingRequest {
    this.competitorInsights = competitorInsights;
    return this;
  }

  getTakenAircraftCategories(): Array<AircraftCategory> {
    return this.takenAircraftCategories;
  }

  setTakenAircraftCategories(categories: Array<AircraftCategory>): SourcingRequest {
    this.takenAircraftCategories = categories;

    return this;
  }

  getParentSourcingRequestId(): string {
    return this.parentSourcingRequestId;
  }

  setParentSourcingRequestId(parentSourcingRequestId: string): SourcingRequest {
    this.parentSourcingRequestId = parentSourcingRequestId;

    return this;
  }

  getBillingCurrency(): CurrencyEnum {
    return this.billingCurrency;
  }

  setBillingCurrency(billingCurrency: CurrencyEnum): SourcingRequest {
    this.billingCurrency = billingCurrency;
    return this;
  }
}
